import { ApiService } from '../../../core/services/api.service';
import { Injectable } from '@angular/core';
import { SessionStateService } from '../../../core/services/session-state.service';
import { JwtService } from '../../../core/services';
import { Reports } from './energy-reports.model';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment as envPrd} from '../../../../environments/environment.prd';
import { environment as envQa} from '../../../../environments/environment.qa';
import { environment } from '../../../../environments/environment';


@Injectable()
export class EnergyReportsService {

  constructor(
    private apiService: ApiService,
    private sessionStateService: SessionStateService,
    private jwtService: JwtService,
    private httpClient: HttpClient,
  ) { }

  getReportsToken() {
    let endPoint;
    const body = {
      house_id: this.sessionStateService.getHouse().houseId,
      id_token: this.sessionStateService.getJwtIdToken()
    };
    if (environment.qa) {
      endPoint = envQa.reports.url + '/api/users/edptoken';
    } else {
      endPoint = envPrd.reports.url + '/api/users/edptoken';
    }

    return this.apiService.post(endPoint, body)
      .map((res: any) => {
        return this.sessionStateService.setReportsToken(res['token'], res['username']);
      });
  }

  getReports() {
    let endPoint;
    const headers = {};
    headers['X-User-Username'] = this.sessionStateService.getReportsUsername();
    headers['X-User-Token'] = this.sessionStateService.getReportsToken();
    headers['Content-Type'] = 'application/json';

    const httpHeaders = new HttpHeaders(headers);
    if (environment.qa) {
      endPoint = envQa.reports.url + '/api/reports';
    } else {
      endPoint = envPrd.reports.url + '/api/reports';
    }
    return this.httpClient.get<any>(endPoint, {headers: httpHeaders })
      .map((reportDTOs: any) => {
        return Reports.fromDTO(reportDTOs);
      });
  }

  getReport(reportId: number) {
    let endPoint;
    const headers = {};
    headers['X-User-Username'] = this.sessionStateService.getReportsUsername();
    headers['X-User-Token'] = this.sessionStateService.getReportsToken();
    headers['Content-Type'] = 'application/json';
    const httpHeaders = new HttpHeaders(headers);
    if (environment.qa) {
      endPoint = envQa.reports.url + `/reports/${reportId}`;
    } else {
      endPoint = envPrd.reports.url + `/reports/${reportId}`;
    }

    return this.httpClient.get<any>(endPoint, {headers: httpHeaders })
      .map((_return: any) => {
        return _return;
      });
  }



}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy-reports/energy-reports.service.ts